import { tWithKeyAttr as t } from "../../i18nHelper";
import noAppointmentsStyles from "./noAppointments.module.css";
import myCalendarImg from "../../images/myCalendarImg.png";
import { useNavigate } from "react-router-dom";
import { Dispatch, SetStateAction } from "react";
import { Category } from "../../types/types";

function NoAppointments({ setActiveCategory }: { setActiveCategory: Dispatch<SetStateAction<Category>> }) {
  const navigate = useNavigate();
  return (
    <div className={noAppointmentsStyles.section}>
      <img
        className={noAppointmentsStyles.section__img}
        src={myCalendarImg}
        alt={t('MAN_WITH_PEN_AND_CALENDAR')}
      />
      <h2 className={noAppointmentsStyles.section__title}>
        {t('MEETINGS_NOT_SCHEDULED_YET')}</h2>
      <button
        type={"button"}
        className={`button ${noAppointmentsStyles.section__btn} hover`}
        onClick={() => {
          setActiveCategory(Category.Help)
          navigate("/home");
        }}
      >
        {t('SET_MEETING_WITH_EXPERT')}</button>
    </div>
  );
}

export default NoAppointments;
